import React from 'react';
import {connect} from 'react-redux';
import {Navigate, useSearchParams} from 'react-router-dom';

import {Dispatch, Store, SessionState} from 'spectra-logic-ui';

import {login} from '../common/fetch';

type Props = {
  session: SessionState;
  authenticated: boolean;
  error?: boolean;
  fetching: boolean;
  onForgotPassword: Function;
  samlLogin: () => any;
}

const LoginPage = ({authenticated, samlLogin, error}: Props) => {
  const [params] = useSearchParams();
  // The server's loginHandler redirects here with ?sso=1 once the SAML
  // session cookie has been established. Only then is it safe to exchange
  // that cookie for an app JWT via POST /api/tokens. On a cold visit (no
  // cookie yet) that request would just 302 to the IdP and fail, so we
  // show the "Login with SSO" link instead.
  const returningFromSso = params.get('sso') === '1';
  const attempted = React.useRef(false);

  React.useEffect(() => {
    if (returningFromSso && !authenticated && !attempted.current) {
      attempted.current = true;
      samlLogin();
    }
  }, [returningFromSso, authenticated, samlLogin]);

  if (authenticated) {
    return <Navigate to='/dashboard' replace={true}/>;
  }

  // Token exchange is in flight after returning from SSO.
  if (returningFromSso && !error) {
    return <p>Signing you in...</p>;
  }

  return (
    <div>
      {error && <p>Error logging in</p>}
      <a href='/api/login'>Login with SSO</a>
    </div>
  );
};

const mapStateToProps = (state: Store) => {
  const session = state['session'] || {};
  return {
    authenticated: session.authenticated,
    error: session.error,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return ({
    samlLogin: () => login(dispatch),
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
